import React from 'react';
import { connect } from 'react-redux';
import BtnGroup from '../BtnGroup/BtnGroup';
import Button from '../Button/Button';
import DepositForm from '../Form/DepositForm';
import WithdrawForm from '../Form/WithdrawForm';
import ExchangeForm from '../Form/ExchangeForm';
import OperationsForm from '../Form/OperationsForm';
import WalletBalance from './WalletBalance';
import DepositFormCrypto from '../Form/DepositFormCrypto';
import WithdrawFormCrypto from '../Form/WithdrawFormCrypto';

const forms = {
  deposit: DepositForm,
  deposit_crypto: DepositFormCrypto,
  withdraw: WithdrawForm,
  withdraw_crypto: WithdrawFormCrypto,
  exchange: ExchangeForm,
  history: OperationsForm,
};

class Wallet extends React.Component {
  static defaultProps = {
    activeForm: 'deposit',
    formProps: {},
    showBalance: true,
  };

  constructor(props) {
    super(props);

    this.state = {
      activeForm: props.activeForm,
    };
  }

  changeForm = (form) => {
    this.setState({ activeForm: form });
  };

  render() {
    const { activeForm } = this.state;
    const { balance, balanceCash, formProps, cryptoEnabled, slotsEnabled } = this.props;

    if (!slotsEnabled && activeForm === 'exchange') return null;

    const Form = forms[activeForm];

    return (
      <div className="wallet">
        <div className="wallet__header">
          <span className="wallet__title">{i18next.t('wallet.title')}</span>
          <BtnGroup>
            <Button
              yellow
              defaultStyles
              onClick={() => this.changeForm('deposit')}
              active={activeForm === 'deposit'}
            >
              {i18next.t('wallet.deposit')}
            </Button>
            {cryptoEnabled && (
              <Button
                yellow
                defaultStyles
                onClick={() => this.changeForm('deposit_crypto')}
                active={activeForm === 'deposit_crypto'}
              >
                {i18next.t('wallet.deposit_crypto')}
              </Button>
            )}
            <Button
              yellow
              defaultStyles
              onClick={() => this.changeForm('withdraw')}
              active={activeForm === 'withdraw'}
            >
              {i18next.t('wallet.withdraw')}
            </Button>
            {cryptoEnabled && (
              <Button
                yellow
                defaultStyles
                onClick={() => this.changeForm('withdraw_crypto')}
                active={activeForm === 'withdraw_crypto'}
              >
                {i18next.t('wallet.withdraw_crypto')}
              </Button>
            )}
            {slotsEnabled && (
              <Button
                yellow
                defaultStyles
                onClick={() => this.changeForm('exchange')}
                active={activeForm === 'exchange'}
              >
                {i18next.t('wallet.exchange')}
              </Button>
            )}
            <Button
              yellow
              defaultStyles
              onClick={() => this.changeForm('history')}
              active={activeForm === 'history'}
            >
              {i18next.t('wallet.history')}
            </Button>
          </BtnGroup>
        </div>

        {this.props.showBalance && (
          <div className="wallet__balances">
            {balance !== null && (
              <WalletBalance currency="REX" balance={balance} />
            )}
            {slotsEnabled && balanceCash !== null && (
              <WalletBalance currency="CASH" balance={balanceCash} />
            )}
          </div>
        )}

        <div className="wallet__forms">
          <Form {...formProps} />
        </div>
      </div>
    );
  }
}

export default connect((state) => {
  return {
    balance: state.user.balance,
    balanceCash: state.user.balanceCash,
    cryptoEnabled: Boolean(state.user.profile.crypto),
    slotsEnabled: Boolean(state.user.profile.slots),
  };
}, {})(Wallet);



// WEBPACK FOOTER //
// ./app/components/Wallet/Wallet.jsx